import { z } from 'zod';

export const errors = [
  {
    status: 400,
    description: 'Bad Request',
    schema: z.object({
      error: z.string(),
    }),
  },
  {
    status: 401,
    description: 'Unauthorized',
    schema: z.object({
      error: z.string(),
    }),
  },
  {
    status: 404,
    description: 'Not Found',
    schema: z.object({
      error: z.string(),
    }),
  },
  {
    status: 500,
    description: 'Internal Server Error',
    schema: z.object({
      error: z.string(),
    }),
  },
];

export const tenantSchema = z.object({
  tenantId: z.string(),
  name: z.string(),
  description: z.string().optional(),
  isActive: z.boolean(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export const linkSchema = z.object({
  shortCode: z.string().length(7),
  tenantId: z.string(),
  redirectURL: z.string().url(),
  title: z.string().optional(),
  description: z.string().optional(),
  isActive: z.boolean(),
  clickCount: z.number(),
  lastAccessedAt: z.number().optional(),
  expiresAt: z.number().optional(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export const apiKeySchema = z.object({
  keyId: z.string(),
  tenantId: z.string().optional(),
  keySuffix: z.string(),
  name: z.string(),
  description: z.string().optional(),
  isActive: z.boolean(),
  isAdmin: z.boolean(),
  lastUsedAt: z.number().optional(),
  expiresAt: z.number().optional(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export const createLinkSchema = z.object({
  redirectURL: z.string().url(),
  title: z.string().optional(),
  description: z.string().optional(),
  expiresAt: z.string().datetime().optional(),
});

export const updateLinkSchema = z.object({
  redirectURL: z.string().url().optional(),
  title: z.string().optional(),
  description: z.string().optional(),
  isActive: z.boolean().optional(),
  expiresAt: z.string().datetime().optional(),
});

export const paginationSchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  cursor: z.string().optional(),
  clickOrder: z.enum(['asc', 'desc']).optional(),
  tenant: z.string().optional(),
});

export const linkListResponseSchema = z.object({
  data: z.array(linkSchema),
  cursor: z.string().optional(),
});